'use client';

import React, { memo } from 'react';

interface LucatConnectFamilyLogoProps {
  className?: string;
}

/**
 * LucatConnectFamilyLogo — composant centralisé et réutilisable.
 * Source unique de vérité pour le logo LUCAT CONNECT Famille dans le header.
 *
 * Structure :
 *   [SYMBOLE LC OFFICIEL]  LUCAT CONNECT
 *                          FAMILLE
 */
const LucatConnectFamilyLogo = memo(function LucatConnectFamilyLogo({
  className = '',
}: LucatConnectFamilyLogoProps) {
  return (
    <div
      className={`flex items-center gap-[8px] flex-shrink-0 ${className}`}
      aria-label="LUCAT CONNECT Famille"
      role="img"
    >
      {/* ── Symbole officiel LC ── */}
      <img
        src="/assets/images/04_LOGO_simple2.jpg-removebg-preview-1785217427044.png"
        alt=""
        aria-hidden="true"
        style={{
          width: '34px',
          height: '34px',
          objectFit: 'contain',
          flexShrink: 0,
        }}
      />

      {/* ── Bloc texte ── */}
      <div
        className="flex flex-col leading-none"
        style={{ gap: '1px' }}
      >
        {/* Ligne 1 : LUCAT CONNECT */}
        <div
          className="flex items-baseline"
          style={{ gap: '4px', whiteSpace: 'nowrap' }}
        >
          <span
            style={{
              color: '#4CBF1A',
              fontWeight: 800,
              fontSize: '15px',
              lineHeight: '18px',
              letterSpacing: '-0.2px',
              whiteSpace: 'nowrap',
            }}
          >
            LUCAT
          </span>
          <span
            style={{
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '15px',
              lineHeight: '18px',
              letterSpacing: '-0.2px',
              whiteSpace: 'nowrap',
            }}
          >
            CONNECT
          </span>
        </div>

        {/* Ligne 2 : FAMILLE */}
        <span
          style={{
            color: 'rgba(255, 255, 255, 0.80)',
            fontWeight: 600,
            fontSize: '9px',
            lineHeight: '11px',
            letterSpacing: '0.6px',
            whiteSpace: 'nowrap',
            textTransform: 'uppercase',
          }}
        >
          FAMILLE
        </span>
      </div>
    </div>
  );
});

export default LucatConnectFamilyLogo;
